import dayjs from "dayjs";

export const formatSharedDate = (isoDate) => {
  const date = new Date(isoDate);
  const options = { day: "2-digit", month: "long" };
  return date.toLocaleDateString("en-US", options);
};

export const formatToISO = (date) => {
  if (!date) return null;
  return dayjs(date).format("YYYY-MM-DD");
};

export const getDateRange = (selected, customDate, customRange) => {
  const today = new Date();
  switch (selected) {
    case "today": {
      return { startDate: formatToISO(today) };
    }

    case "yesterday": {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return { startDate: formatToISO(yesterday) };
    }

    case "last_7_days": {
      const start7 = new Date(today);
      start7.setDate(today.getDate() - 6);
      return {
        startDate: formatToISO(start7),
        endDate: formatToISO(today),
      };
    }

    case "last_14_days": {
      const start14 = new Date(today);
      start14.setDate(today.getDate() - 13);
      return {
        startDate: formatToISO(start14),
        endDate: formatToISO(today),
      };
    }

    case "custom_date": {
      return { startDate: formatToISO(customDate) };
    }

    case "date_range": {
      return {
        startDate: formatToISO(customRange?.startDate),
        endDate: formatToISO(customRange?.endDate),
      };
    }

    default:
      return {};
  }
};

export const getPresetRange = (type) => {
  const today = dayjs();
  switch (type) {
    case "today":
      return [today.startOf("day"), today.endOf("day")];
    case "yesterday":
      return [
        today.subtract(1, "day").startOf("day"),
        today.subtract(1, "day").endOf("day"),
      ];
    case "last_7_days":
      return [today.subtract(6, "day").startOf("day"), today.endOf("day")];
    case "last_14_days":
      return [today.subtract(13, "day").startOf("day"), today.endOf("day")];
    default:
      return [null, null];
  }
};

export const formatDateRange = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
};
